import { useContext, useEffect, useMemo, useRef, useState } from "react";
import UserImg2 from "../../assets/img/bank-icon.svg";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import useTranslator from "../../hooks/useTranslator";
import { Form, Modal } from "react-bootstrap";
import { BsBank2 } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import axiosInstanceInstance from "../../services/authWrapper";
import axiosInstance from "../../services/authWrapper";
import TenantContext from "../../context/tenant/TenantContext";
import CheckIcon from "../../assets/img/checkmark-circle02.svg";
import { sendUniversalMail } from "../../services/sharedService";
import ProcessPassedModal from "./ProcessPassedModal";
import { trackClarityEvent } from "../../Utils/clarityReady";
import { toast, haveValue } from "../../helper/common";
import constants from "../../Utils/constants";
import moment from "moment";
import styles from "./BankModal.module.css";

const BankModal = ({
  user,
  formHandler,
  updateUserProfile,
  isGuarantor,
  isCoTenant = false,
  loadGuarantorData,
  loadCoTenantData,
  guarantor_a_id,
  co_tenant_a_id,
  usedFor,
  setBankshow: setBankshowProp,
  loadFullInfo,
  setPaymentScoreLoading,
  reconnectFlow = false,
  getAnalysisDetails,
  setScoreValue,
  originalUser,
  setFinancial_info_errors,
  modules,
  handleSubmitFinalStep,
  isDummySignup,
  setTinkModal,
  isBankAdded,
  setStep,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { loadUser, userType, loadUserTenant, setLoading } =
    useContext(AuthContext);
  const { uploadBankStatement, sendRemoteConnectLink } =
    useContext(TenantContext);
  const [bankShow, setBankShow] = useState(false);

  const getGuarantorCompletionPath = () => {
    const returnTo = new URLSearchParams(window.location.search).get(
      "returnTo"
    );
    if (returnTo?.startsWith("/") && !returnTo.startsWith("//")) {
      return returnTo;
    }
    return `/home${
      originalUser?.gurantor_added_id?.length === 0 ? "?welcome=true" : ""
    }`;
  };
  const getCoTenantCompletionPath = () => {
    const returnTo = new URLSearchParams(window.location.search).get(
      "returnTo"
    );
    if (returnTo?.startsWith("/") && !returnTo.startsWith("//"))
      return returnTo;
    return "/home?welcome=true";
  };
  const [tink_countryCode, setTink_countryCode] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const queryParameters = new URLSearchParams(window.location.search);
  const error1 = queryParameters.get("error");
  let account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  let transaction_report_id = queryParameters.get("transaction_report_id");
  const [calculatingScoreLoading, setCalculatingScoreLoading] = useState(false);
  const [uploadStatementLoading, setUploadStatementLoading] = useState(false);
  const [uploadStatementStatus, setUploadStatementStatus] = useState(false);
  const [submitStepLoading, setSubmitStepLoading] = useState(false);
  const [reuploadStatement, setReuploadStatement] = useState(false);
  const [showTickScreen, setShowTickScreen] = useState(false);
  const [showBankAccountConnectedScreen, setShowBankAccountConnectedScreen] =
    useState(false);
  const [doItLaterLoading, setDoItLaterLoading] = useState(false);
  const [sendLinkLoading, setSendLinkLoading] = useState(false);
  const [sendLinkSuccess, setSendLinkSuccess] = useState(false);

  const close = () => {
    if (setBankshowProp) {
      setBankshowProp(false);
    } else {
      setBankShow(false);
    }
  };

  const isExpiredRenewal = useMemo(() => {
    if (!user?.re_new_pending) return false;
    const dateToCheck = haveValue(user?.bankVerificationDate)
      ? user.bankVerificationDate
      : user?.created_at;
    if (!dateToCheck) return false;
    const expiryDate = moment(dateToCheck).add(2, "months");
    return expiryDate.isBefore(moment(), "day");
  }, [user?.re_new_pending, user?.bankVerificationDate, user?.created_at]);

  const handleBack = () => {
    if (usedFor === "popup") {
      close();
      return;
    }
    formHandler?.prev?.();
    formHandler?.prev?.();
    formHandler?.prev?.();
  };

  const isUploadedCSV =
    user?.bank_details?.userDataByProvider?.[0]?.providerName ===
      "Uploaded from CSV" || uploadStatementStatus;

  // Exact original logic: show options only when no bank is connected (or reconnect/expired flows)
  const shouldShowOptionsScreen =
    (reconnectFlow && !reuploadStatement && !showBankAccountConnectedScreen) ||
    (isExpiredRenewal &&
      !uploadStatementStatus &&
      !showBankAccountConnectedScreen) ||
    (!uploadStatementStatus &&
      !showBankAccountConnectedScreen &&
      (!user?.bank_details || !user.bank_details?.userDataByProvider?.length));

  const isCompletedForSubmit = isUploadedCSV || sendLinkSuccess;
  const isLoading =
    calculatingScoreLoading || uploadStatementLoading || sendLinkLoading;

  useEffect(() => {
    if (isDummySignup) return;

    if (error1) {
      toast.error(_t("bankDetailsCannotBeFetched"));
    }
    if (account_verification_report_id && transaction_report_id) {
      let userid = user?._id;
      if (!userid) {
        toast.error(_t("userNotAuthorized"));
      } else {
        calculateScore(
          userid,
          account_verification_report_id,
          transaction_report_id
        );
      }
    }
  }, [account_verification_report_id]);

  const calculateScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    if (isDummySignup) return;

    account_verification_report_id = null;
    transaction_report_id = null;
    await clearPaymentData(userid);
    if (isGuarantor) {
      loadGuarantorData("applyProfile", null, false);
    } else if (isCoTenant) {
      loadCoTenantData?.("applyProfile", null, false);
    } else {
      loadUserTenant(localStorage.getItem("usertype"));
    }
    calculatePaymentScore(userid, accountverificationid, transactionreportid);
  };

  const calculatePaymentScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    if (isDummySignup) return;

    let url = `${process.env.REACT_APP_SERVER_URL}/tenants/calculatescore?tenantid=${userid}&accountverificationid=${accountverificationid}&transactionreportid=${transactionreportid}`;
    if (isGuarantor) {
      url += "&guarantor=true";
    }
    if (isGuarantor || isCoTenant) {
      setShowTickScreen(true);
    } else {
      setShowBankAccountConnectedScreen(true);
    }

    setTimeout(async () => {
      if (isGuarantor) {
        sendGuarantorRequest();
      } else if (isCoTenant) {
        handleSubmitStep();
      } else {
        handleSubmitStep();
        if (window.location.pathname === "/onboarding") {
          trackClarityEvent("tenant_bank_connect_step_ended");
          setTimeout(() => {
            trackClarityEvent("tenant_guarantor_step_started");
          }, constants.CLARITY_DELAY);
        }
      }
    }, 2000);

    axiosInstanceInstance
      .get(url)
      .then((res) => {
        let serverResponse = res.data;
        if (serverResponse.status !== "success") {
          if (serverResponse.status == "pending") {
          } else {
            trackClarityEvent("tenant_bank_connect_failed");
            toast.error(_t("skorCanNotBeCalculated"));
          }
        }
        if (serverResponse.status === "success") {
          if (isGuarantor) {
            loadGuarantorData("applyProfile", null, false);
          } else if (isCoTenant) {
            loadCoTenantData?.("applyProfile", null, false);
          } else {
            trackClarityEvent("tenant_bank_connected");
            loadUser(userType);
          }
        }
        const url = new URL(window.location);
        url.searchParams.delete("account_verification_report_id");
        url.searchParams.delete("transaction_report_id");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      })
      .catch(() => {
        setCalculatingScoreLoading(false);
      });
  };

  const clearPaymentData = async (tenantid) => {
    if (isDummySignup) return Promise.resolve(true);

    return new Promise((resolve) => {
      let url = `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`;
      if (isGuarantor) {
        url += "&guarantor=true";
      }
      axiosInstance
        .delete(url)
        .then((res) => {
          return resolve(true);
        })
        .catch((err) => {
          let err_res = err;
          toast.error(err_res.message);
          return resolve(null);
        });
    });
  };

  const openBankModal = () => {
    setBankShow(true);
  };
  const BankhandleClose = () => {
    close();
  };

  const changeCountryCode = (e) => {
    setTink_countryCode(e.target.value);
  };

  const connectToBank = () => {
    // In dummy mode, simulate a successful digital bank connection
    if (isDummySignup) {
      setTinkModal(true);
      setBankShow(false);
      return;
    }

    if (!tink_countryCode) {
      setCountryCodeError(_t("pleaseSelectCountryCode"));
      return;
    } else {
      setCountryCodeError("");
    }
    var lang = "en_US";
    if (localStorage.getItem("i18nextLng") == "es") {
      lang = "es_ES";
    }

    let baseUrl = `https://link.tink.com/1.0/reports/create-report?client_id=${process.env.REACT_APP_TINK_CLIENT_ID}&market=${tink_countryCode}&locale=${lang}&report_types=TRANSACTION_REPORT,ACCOUNT_VERIFICATION_REPORT&refreshable_items=IDENTITY_DATA,CHECKING_ACCOUNTS,SAVING_ACCOUNTS,CHECKING_TRANSACTIONS,SAVING_TRANSACTIONS&account_dialog_type=NONE`;

    let tinkUrlLiveFront;

    if (usedFor === "popup") {
      if (isGuarantor) {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fhome?guarantor=${user?._id}`;
      } else if (isCoTenant) {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fhome?co_tenant=${user?._id}`;
      } else {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fhome`;
      }
    } else {
      if (isGuarantor) {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fguarantor%2Fonboarding?guarantor_a_id=${guarantor_a_id}`;
      } else if (isCoTenant) {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fco-tenant%2Fonboarding?co_tenant_a_id=${co_tenant_a_id}`;
      } else {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fonboarding`;
      }
    }

    window.open(tinkUrlLiveFront, "_self");
  };

  const handleTempUploadFile = async (e) => {
    // In dummy mode, simulate a successful upload without any API call
    if (isDummySignup) {
      setUploadStatementStatus(true);
      setReuploadStatement(true);
      return;
    }

    const files = e.target.files;
    let file = files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenant_id", user?._id);
    try {
      if (usedFor === "popup") {
        await updateUserProfile({
          bank_status: true,
          paymentScores: null,
          financial_info_errors: null,
          role: "tenant",
        });
        setFinancial_info_errors(null);
        setScoreValue(null);
        setPaymentScoreLoading(true);
        await loadFullInfo(false);
        getAnalysisDetails();
      }
      setUploadStatementLoading(true);
      await uploadBankStatement(formData);
      setUploadStatementStatus(true);
      setReuploadStatement(true);
    } catch (err) {
      console.log("Error: ", err);
    } finally {
      setUploadStatementLoading(false);
    }
  };

  const sendGuarantorRequest = async () => {
    if (isDummySignup) return;

    await sendMail(user?.email, "score");
  };

  const sendMail = async (receiverEmail, emailType) => {
    if (isDummySignup) return;

    let payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "processing",
    };
    if (haveValue(guarantor_a_id)) {
      payload.guarantorRequestId = guarantor_a_id;
    }
    try {
      await sendUniversalMail(payload);
      toast.success(_t("emailSent"));
    } catch (err) {
      toast.error(_t("errorSendingMail"), err?.message);
      throw err;
    }
  };

  const handleDoItLater = async () => {
    if (doItLaterLoading) return;

    // In dummy mode, just navigate without any API call
    if (isDummySignup) {
      setStep(7);
      return;
    }
    setLoading(true);
    let formData = {};
    let step = 7;
    if (isGuarantor || isCoTenant || user?.gurantor_for?.length > 0) {
      formData = {
        profile_completed: true,
        role: localStorage.getItem("usertype"),
        is_edit: false,
        lang: localStorage.getItem("i18nextLng"),
      };
    } else {
      if (Array.isArray(modules)) {
        if (modules.includes("DISABLE_GUARANTORS")) {
          step = -1;
        }
      }
      formData = {
        step: step,
        role: localStorage.getItem("usertype"),
      };
      trackClarityEvent("tenant_bank_connect_step_skipped");
      setTimeout(() => {
        trackClarityEvent("tenant_guarantor_step_started");
      }, constants.CLARITY_DELAY);
    }

    try {
      setDoItLaterLoading(true);

      if (step === -1) {
        handleSubmitFinalStep();
      } else {
        await updateUserProfile(formData);
      }

      if (isGuarantor) {
        await sendGuarantorRequest();
        navigate(getGuarantorCompletionPath());
      } else if (isCoTenant) {
        navigate(getCoTenantCompletionPath());
      } else if (user?.gurantor_for?.length > 0) {
        navigate(`/home`);
      }
    } catch (err) {
    } finally {
      setLoading(false);
      setDoItLaterLoading(false);
    }
  };

  const handleSubmitStep = async (sendRequest = false) => {
    // In dummy mode, just navigate without any API call
    if (isDummySignup) {
      setStep(7);
      try {
        sessionStorage.removeItem("dummy_basic_info");
      } catch (e) {}
      return;
    }

    try {
      setSubmitStepLoading(true);
      let formData = {};
      let step = 7;
      if (isGuarantor || isCoTenant || user?.gurantor_for?.length > 0) {
        formData = {
          profile_completed: true,
          role: "tenant",
          is_edit: false,
        };
      } else {
        if (Array.isArray(modules)) {
          if (modules.includes("DISABLE_GUARANTORS")) {
            step = -1;
          }
        }
        formData = {
          step: step,
          role: localStorage.getItem("usertype"),
        };
      }

      if (step === -1) {
        handleSubmitFinalStep();
      } else {
        await updateUserProfile(formData);
      }

      if (sendRequest && isGuarantor) {
        await sendGuarantorRequest();
      }

      if (isGuarantor) {
        navigate(getGuarantorCompletionPath());
      } else if (isCoTenant) {
        navigate(getCoTenantCompletionPath());
      } else if (user?.gurantor_for?.length > 0) {
        navigate(`/home`);
      }
    } catch (err) {
      console.log("Error", err);
    } finally {
      setSubmitStepLoading(false);
    }
  };

  const sendRemoteConnectToBank = async () => {
    // In dummy mode, simulate a successful link send
    if (isDummySignup) {
      setSendLinkSuccess(true);
      setBankShow(false);
      return;
    }

    setSendLinkLoading(true);

    try {
      const payload = {
        guarantor_id: user?._id,
      };
      const response = await sendRemoteConnectLink(payload);
      if (response?.success) {
        setSendLinkSuccess(true);
      }
    } catch (error) {
      toast.error(_t("errorSendingTinkLink"));
    } finally {
      setSendLinkLoading(false);
      close();
    }
  };

  return (
    <>
      <div
        className={[
          "popup-overlay",
          "wrapper-modal",
          "modal-fixed-screen",
          styles.overlay,
        ].join(" ")}
        onClick={usedFor === "popup" ? () => close() : null}
      >
        {!bankShow && (
          <section
            className={`${styles.bankPanel} onboarding-modal-surface`}
            aria-labelledby="verify-income-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className={styles.backButton}
              onClick={handleBack}
            >
              <span aria-hidden="true">‹</span>
              {_t("goBack")}
            </button>

            {usedFor === "popup" && (
              <button
                type="button"
                className={styles.closeButton}
                onClick={close}
                aria-label={_t("close", "Close")}
              >
                ×
              </button>
            )}

            <div className={styles.bankIcon} aria-hidden="true">
              <img src={UserImg2} alt="" />
            </div>

            {/* Keep original header variants but with compact new styling */}
            {isExpiredRenewal &&
            !showBankAccountConnectedScreen &&
            !uploadStatementStatus ? (
              <header className={styles.header}>
                <h1 id="verify-income-title">
                  {_t("financialCheck", "Financial check")}
                </h1>
                <p>
                  {_t(
                    "oneLastStepToFinishUpdatingYourProfile",
                    "One last step to finish updating your profile."
                  )}
                </p>
              </header>
            ) : (
              <header className={styles.header}>
                <h1 id="verify-income-title">
                  {_t("verifyIncome", "Verify your income")}
                </h1>
                <p>
                  {_t(
                    "verifiedIncomeMakesYourProfileStandOut",
                    "With your income verified, your profile stands out to landlords. It takes about 2 minutes."
                  )}
                </p>
              </header>
            )}

            {isExpiredRenewal &&
              !uploadStatementStatus &&
              !showBankAccountConnectedScreen && (
                <p className={styles.warning}>
                  {_t(
                    "evenThoughYouConnectedYourBankBeforeThatConnectionHasExpired",
                    "Your previous bank connection has expired. Choose an option below to update your financial information."
                  )}
                </p>
              )}

            <div className={styles.options}>
              {isLoading ? (
                <div className={styles.loadingState} role="status">
                  <img src={SkorDefaultLoader} alt="" />
                  <span>
                    {sendLinkLoading
                      ? _t("sendingLinkToGuarantor", "Sending link…")
                      : _t("processing", "Processing…")}
                  </span>
                </div>
              ) : shouldShowOptionsScreen ? (
                <>
                  {calculatingScoreLoading ? (
                    <div className={styles.loadingState} role="status">
                      <img src={SkorDefaultLoader} alt="" />
                      <span>{_t("processing", "Processing…")}</span>
                    </div>
                  ) : (
                    <>
                      <button
                        type="button"
                        className={`${styles.option} ${styles.primaryOption}`}
                        onClick={
                          isGuarantor
                            ? () => fileInputRef.current?.click()
                            : openBankModal
                        }
                      >
                        <span className={styles.optionCopy}>
                          <span className={styles.optionHeading}>
                            <strong>
                              {isGuarantor
                                ? _t(
                                    "uploadBankStatement",
                                    "Text used in guarantor screen at onboarding flow"
                                  )
                                : isExpiredRenewal
                                  ? _t(
                                      "connectBankDigitally",
                                      "Connect bank digitally"
                                    )
                                  : _t(
                                      "verifyBankDigitally",
                                      "Text used in guarantor screen at onboarding flow"
                                    )}
                            </strong>
                            {!isGuarantor && (
                              <span className={styles.badge}>
                                {_t("fastest", "Fastest")}
                              </span>
                            )}
                          </span>
                          <span className={styles.optionDescription}>
                            {isGuarantor
                              ? _t(
                                  "bankStatementWithOnlyEuroAccountsAndShouldNotBeOlderThan3Months",
                                  "Text used in guarantor screen at onboarding flow"
                                )
                              : _t(
                                  "getYourIncomeVerifiedDigitally",
                                  isExpiredRenewal
                                    ? "Get your income verified digitally"
                                    : "Text used in guarantor screen at onboarding flow"
                                )}
                          </span>
                          {!isGuarantor && (
                            <span className={styles.optionMeta}>
                              {_t("countries")}:{" "}
                              {[
                                "belgium",
                                "germany",
                                "denmark",
                                "estonia",
                                "spain",
                                "finland",
                                "france",
                                "united kingdom",
                                "italy",
                                "lithuania",
                                "latvia",
                                "netherlands",
                                "norway",
                                "poland",
                                "portugal",
                                "sweden",
                              ].map((country, index, arr) => (
                                <span key={country}>
                                  {_t(country)}
                                  {index !== arr.length - 1 && ", "}
                                </span>
                              ))}
                            </span>
                          )}
                        </span>
                        <span className={styles.arrow} aria-hidden="true">
                          →
                        </span>
                      </button>

                      {!isGuarantor ? (
                        <button
                          type="button"
                          className={`${styles.option} ${styles.secondaryOption}`}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          <span className={styles.optionCopy}>
                            <strong>
                              {_t(
                                "uploadBankStatement",
                                isExpiredRenewal
                                  ? "Upload bank statement"
                                  : "Text used in guarantor screen at onboarding flow"
                              )}
                            </strong>
                            <span className={styles.optionDescription}>
                              {isExpiredRenewal
                                ? _t(
                                    "uploadYourLast3Months",
                                    "Upload your last 3 months"
                                  )
                                : _t(
                                    "bankStatementWithOnlyEuroAccountsAndShouldNotBeOlderThan3Months",
                                    "Text used in guarantor screen at onboarding flow"
                                  )}
                            </span>
                          </span>
                          <span className={styles.arrow} aria-hidden="true">
                            →
                          </span>
                        </button>
                      ) : sendLinkSuccess ? (
                        <div
                          className={`${styles.option} ${styles.secondaryOption} ${styles.statusOption}`}
                          role="status"
                        >
                          <span className={styles.optionCopy}>
                            <strong>
                              {_t(
                                reconnectFlow
                                  ? "linkSentSuccessfully"
                                  : "linkWillBeSentWhenGuarantorAcceptsRequest"
                              )}
                            </strong>
                          </span>
                          <span className={styles.arrow} aria-hidden="true">
                            ✓
                          </span>
                        </div>
                      ) : (
                        <button
                          type="button"
                          className={`${styles.option} ${styles.secondaryOption}`}
                          onClick={
                            sendLinkLoading
                              ? undefined
                              : sendRemoteConnectToBank
                          }
                        >
                          <span className={styles.optionCopy}>
                            <strong>
                              {sendLinkLoading
                                ? _t("sendingLinkToGuarantor")
                                : _t(
                                    reconnectFlow
                                      ? "sendBankConnectLinkToGuarantor"
                                      : "sendBankVerificationLinkWhenGuarantorAccepts"
                                  )}
                            </strong>
                          </span>
                          <span className={styles.arrow} aria-hidden="true">
                            →
                          </span>
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : isUploadedCSV ? (
                <div
                  className={`${styles.option} ${styles.secondaryOption} ${styles.statusOption}`}
                  role="status"
                >
                  <span className={styles.optionCopy}>
                    <span className={styles.optionHeading}>
                      <strong>
                        {_t(
                          "uploadBankStatement",
                          "Text used in guarantor screen at onboarding flow"
                        )}
                      </strong>
                      <span className={styles.completeBadge}>
                        <img src={CheckIcon} alt="" />
                        {_t("bankStatementAdded")}
                      </span>
                    </span>
                    <span className={styles.optionDescription}>
                      {_t(
                        "bankStatementWithOnlyEuroAccountsAndShouldNotBeOlderThan3Months",
                        "Text used in guarantor screen at onboarding flow"
                      )}
                    </span>
                  </span>
                </div>
              ) : (
                <div
                  className={`${styles.option} ${styles.secondaryOption} ${styles.statusOption}`}
                  role="status"
                >
                  <span className={styles.optionCopy}>
                    <span className={styles.optionHeading}>
                      <strong>
                        {_t(
                          "verifyBankDigitally",
                          "Text used in guarantor screen at onboarding flow"
                        )}
                      </strong>
                      <span className={styles.completeBadge}>
                        <img src={CheckIcon} alt="" />
                        {_t("bankAccountConnected")}
                      </span>
                    </span>
                    <span className={styles.optionDescription}>
                      {_t(
                        "getYourIncomeVerifiedDigitally",
                        "Text used in guarantor screen at onboarding flow"
                      )}
                    </span>
                  </span>
                </div>
              )}
              <input
                type="file"
                ref={fileInputRef}
                accept="application/pdf,text/csv"
                id="bankStatementFile"
                className={styles.fileInput}
                onChange={handleTempUploadFile}
              />
            </div>

            {/* Original submit logic: show only when CSV/upload or sendLinkSuccess */}
            {isCompletedForSubmit ? (
              <button
                type="button"
                className={styles.submitButton}
                onClick={() => {
                  if (usedFor === "popup") return close();
                  if (isGuarantor) return setShowTickScreen(true);
                  handleSubmitStep();
                }}
                disabled={submitStepLoading}
              >
                {submitStepLoading ? `${_t("submitting")}...` : _t("submit")}
              </button>
            ) : (
              !isLoading && (
                <button
                  type="button"
                  className={styles.laterButton}
                  onClick={handleDoItLater}
                  disabled={doItLaterLoading}
                >
                  <span>{_t("iWillDoItLater", "I'll do it later")}</span>
                  <span>
                    {_t(
                      "youCanDoItFromYourProfile",
                      "You can do it from your profile"
                    )}
                  </span>
                </button>
              )
            )}

            <p className={styles.securityNote}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 10V7a5 5 0 0 1 10 0v3M6 10h12a1 1 0 0 1 1 1v9H5v-9a1 1 0 0 1 1-1Z" />
              </svg>
              {_t(
                "encryptedConnectionThroughTink",
                "Encrypted connection through Tink (Visa), regulated under PSD2."
              )}
            </p>
          </section>
        )}
        <Modal
          show={bankShow}
          onHide={BankhandleClose}
          centered
          className="newmodalui connectbankmodal"
          size="lg"
          onClick={
            usedFor === "popup" || isGuarantor
              ? (e) => e.stopPropagation()
              : null
          }
        >
          <Modal.Body className="p-0">
            <div className="row">
              <div className="col-sm-6 p-2 bankimagediv">
                <p>
                  {_t(
                    "youWillNowBeRedirectedToConnectYourBankAccountThroughOurPartnerTinkPoweredByVisa"
                  )}
                </p>
                <p>
                  {_t(
                    "itsImportantForYouToKnowThatWeDoNotHaveDirectAccessToYourBankLoginDetails"
                  )}
                  {_t(
                    "thisProcessIsDesignedToMaintainYourCredentialsEncriptedFromSkorOrAnyOtherThirdParty"
                  )}
                </p>
                <img src="/images/connect_bank.svg" alt="bank_logo" />
                <p>
                  {_t(
                    "weAssureYouOfTheUtmostPrivacyAndSecurityOfYourFinancialData"
                  )}
                </p>
              </div>
              <div className="col-sm-6 p-2 connectbankdiv">
                <h3 className="position-relative">
                  <img
                    src="/images/arrow-right.svg"
                    className="arrowBack"
                    onClick={BankhandleClose}
                  />
                  {_t("connectBank")}
                </h3>
                <Form className="loginform">
                  <div className="auth-form">
                    <div className="bigform h-auto w-100">
                      <div className="form-grid w-100">
                        <div className="form-group w-100">
                          <label className="">{_t("country")}</label>
                          <select
                            id="employment_status"
                            onChange={changeCountryCode}
                          >
                            <option value="">{_t("selectYourCountry")}</option>
                            <option value="BE">{_t("belgium")}</option>
                            <option value="DE">{_t("germany")}</option>
                            <option value="DK">{_t("denmark")}</option>
                            <option value="EE">{_t("estonia")}</option>
                            <option value="ES">{_t("spain")}</option>
                            <option value="FI">{_t("finland")}</option>
                            <option value="FR">{_t("france")}</option>
                            <option value="GB">{_t("unitedKingdom")}</option>
                            <option value="IT">{_t("italy")}</option>
                            <option value="LT">{_t("lithuania")}</option>
                            <option value="LV">{_t("latvia")}</option>
                            <option value="NL">{_t("netherlands")}</option>
                            <option value="NO">{_t("norway")}</option>
                            <option value="PL">{_t("poland")}</option>
                            <option value="PT">{_t("portugal")}</option>
                            <option value="SE">{_t("sweden")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="forminput row100 forminput-style">
                      <div
                        className="bankname bankname-style"
                        onClick={connectToBank}
                      >
                        <BsBank2 />
                        {_t("connectBank")}
                      </div>
                      <span className="addRedColor">{countryCodeError}</span>
                    </div>
                  </div>
                </Form>
                <div className="bank-btm">
                  {_t("shouldYouHaveAnyConcernsOrQuestionsPlease")}
                  <a
                    href={undefined}
                    onClick={(e) => navigate("/bank")}
                    className="btnlink"
                  >
                    {_t("readHere")}
                  </a>
                  {_t("orContactUsAt")}
                  <a href="mailTo:info@skortorent.com" className="btnlink">
                    info@skortorent.com.
                  </a>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <ProcessPassedModal
          heading={
            isGuarantor
              ? `${_t("guarantorsOnboradingSuccessful")}`
              : _t("onboardingSuccessful")
          }
          subheading={
            isGuarantor
              ? `${_t(
                  "guarantorsOnboardingHasBeenSuccessfullyCompletedMailhasbeensenton"
                )} ${user?.email}`
              : _t("yourOnboardingHasBeenSuccessfullyCompleted")
          }
          showPopup={showTickScreen}
          buttonText={"goHome"}
          handleClick={() => handleSubmitStep(true)}
        />
      </div>
    </>
  );
};

export default BankModal;
